import React from 'react';

import { useRedirect } from 'react-admin';

import { Button, Tooltip } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

import { RuleTypes } from '../../../../constants/ruleTypes';
import { RuleViews } from '../../../../constants/ruleView';
import { usePendingReviewBlocked } from '../../../../context/PendingReviewContext';

const PENDING_REVIEW_TOOLTIP = 'A review is pending — changes are blocked until it\'s resolved';

const Create = ({ ruleType, view } : {ruleType: RuleTypes; view: RuleViews}) => {
  const redirect = useRedirect();
  const isPendingReviewBlocked = usePendingReviewBlocked();

  return (
    <Tooltip title={isPendingReviewBlocked ? PENDING_REVIEW_TOOLTIP : ''}>
      <span style={{ display: 'inline-flex' }}>
        <Button
          startIcon={<AddIcon />}
          disabled={isPendingReviewBlocked}
          onClick={() => redirect('create', 'rules', undefined, undefined, { record: { ruleType, view } })}
        >
          Create
        </Button>
      </span>
    </Tooltip>
  );
};

export default Create;
